import { C8HttpClientOptions } from './c8-http-client-options';

export class E8HttpClientRequestContext {
    url: string;
    parameter: any;
    options: C8HttpClientOptions;
    method: string;
}
